import axios from 'axios';
import { API_URL, getAuthConfig } from './api';


const _err = (error) => {
    if (error.response) {
        console.error('Auth API error:', error.response.status, error.response.data);
    } else {
        console.error('Auth API error:', error.message);
    }
};


// POST /api/auth/register/   {email, password, full_name?}
export const APIAuthRegister = async ({ email, password, full_name }) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/register/`,
            { email, password, full_name },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /api/auth/login/   {email, password}
export const APIAuthLogin = async ({ email, password }) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/login/`,
            { email, password },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /api/auth/logout/
export const APIAuthLogout = async (token) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/logout/`,
            {},
            getAuthConfig(token, 'email')
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /api/auth/verify-email/   {token}
export const APIAuthVerifyEmail = async (verifyToken) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/verify-email/`,
            { token: verifyToken },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /api/auth/resend-verification/   (auth required)
export const APIAuthResendVerification = async (token) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/resend-verification/`,
            {},
            getAuthConfig(token)
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /api/auth/request-password-reset/   {email}
export const APIAuthRequestPasswordReset = async (email) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/request-password-reset/`,
            { email },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /api/auth/reset-password/   {token, new_password}
export const APIAuthResetPassword = async ({ token, new_password }) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/reset-password/`,
            { token, new_password },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /api/auth/change-password/   (auth required) {old_password, new_password}
export const APIAuthChangePassword = async (token, { old_password, new_password }) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/change-password/`,
            { old_password, new_password },
            getAuthConfig(token)
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};


// POST /api/auth/set-email/   (auth required) {email, password}
export const APIAuthSetEmail = async (token, { email, password }) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/set-email/`,
            { email, password },
            getAuthConfig(token)
        );
        return response.data;
    } catch (e) { _err(e); throw e; }
};

// ===================== Онбординг: анкета -> регистрация =====================

// GET /api/hobbies/ — публичный справочник (гость заполняет анкету без токена)
export const APIPublicHobbies = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/hobbies/`);
        return response.data;            // { hobbies: [{id, name, category}], count }
    } catch (e) { _err(e); throw e; }
};

// GET /api/fields-of-activity/ — публичный справочник сфер деятельности
export const APIPublicFields = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/fields-of-activity/`);
        return response.data;            // { fields: [{id, name, category}], count }
    } catch (e) { _err(e); throw e; }
};

// POST /api/auth/register-with-profile/  (multipart/form-data)
// Аккаунт (email, телефон, пароль) + анкета + фото одним запросом.
export const APIRegisterWithProfile = async (formData) => {
    try {
        const response = await axios.post(
            `${API_URL}/api/auth/register-with-profile/`,
            formData,
            { timeout: 60000 },          // фото + геокодирование на сервере
        );
        return response.data;            // { success, token, user, profile_status, system_settings }
    } catch (e) { _err(e); throw e; }
};